import Api from '@/services/Api'

const root = 'beans'

class BeanService {
  findAll () {
    return Api().get(root)
  }

  findByClasstype (classtype) {
    return Api().get(`${root}/${classtype}`)
  }
}

export default new BeanService()
